if (!customElements.get('accordion-item')) {
  customElements.define(
    'accordion-item',
    class AccordionItem extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.accordion-item__trigger');
        this.panel = this.querySelector('.accordion-item__panel');
        this.list = this.closest('accordion-list');

        this.trigger.addEventListener('click', () => {
          this.isOpen() ? this.close() : this.open();
        });

        // accordion-list.js can load after this file, so the parent may not
        // be upgraded yet - wait for its definition before registering.
        if (this.list) {
          customElements.whenDefined('accordion-list').then(() => this.list.register(this));
        }
      }

      isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      open() {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
        if (typeof this.list?.handleOpen === 'function') this.list.handleOpen(this);
      }

      close() {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
      }
    }
  );
}
